<template>

	<ul class="list-unstyled">

		<li v-for="topic in topics" :key="topic.id" class="py-2 border-bottom border-primary d-flex">
			<template v-if="topic.parent">
				<router-link :to="{name:'topic', params:{parenttopic:topic.parent.url_key, topic:topic.url_key}}">
						<highlight :msg="topic.parent.name" :search="query" effect="highlight" /> » <highlight :msg="topic.name" :search="query" effect="highlight" />
					</router-link>
			</template>
			<template v-else>
				<router-link :to="{name:'topic', params:{parenttopic:topic.url_key}}">
					<highlight :msg="topic.name" :search="query" effect="highlight" />
				</router-link>
			</template>
		</li>
	</ul>

</template>
<script>
import HighlightComponent from "./Highlight.vue";

export default {
  props: ["topics", "query"],
  components: {
    Highlight: HighlightComponent
  }
};
</script>
